const stringMandateConstraints = {
  presence: {
    allowEmpty: false,
    message: 'cannot be empty'
  },
  type: 'string'
};

export { stringMandateConstraints };
